"use strict";

exports.__esModule = true;
exports.MetricChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Metrics = require("../../../Catalogs/Metrics");
var _Core = require("../../Core");
var _Time = require("../../Time");
var _RealtimeMetricChartElement = require("./RealtimeMetricChartElement");
var _HistoricalMetricChartElement = require("./HistoricalMetricChartElement");
var _dec, _dec2, _dec3, _class, _MetricChartElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a chart for a particular metric.
 */
var MetricChartElement = exports.MetricChartElement = (_dec = _Time.TimeContext.withContext, _dec2 = _Time.ReportingPeriodContext.withContext, _dec3 = _Core.SelectionContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = (_MetricChartElement = /*#__PURE__*/function (_Component) {
  function MetricChartElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(MetricChartElement, _Component);
  var _proto = MetricChartElement.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      time = _this$props.time,
      reportingPeriod = _this$props.reportingPeriod,
      selection = _this$props.selection,
      dataRange = _this$props.dataRange;
    var selectedPeriod = dataRange === "SELECTION" && selection && selection.selected.reportingPeriod ? selection.selected.reportingPeriod.interval : reportingPeriod.interval;
    var isCurrent = (0, _Metrics.canSubscribeToRealtime)(time.currentWorkday.interval, time.currentShift.interval, selectedPeriod);
    if (isCurrent) {
      return /*#__PURE__*/_react["default"].createElement(_RealtimeMetricChartElement.RealtimeMetricChartElement, this.props);
    }
    return /*#__PURE__*/_react["default"].createElement(_HistoricalMetricChartElement.HistoricalMetricChartElement, this.props);
  };
  return MetricChartElement;
}(_react.Component), _MetricChartElement.defaultProps = {
  reportingPeriod: undefined,
  selection: undefined,
  time: undefined
}, _MetricChartElement)) || _class) || _class) || _class);